import { render, staticRenderFns } from "./OrderLineComment.vue?vue&type=template&id=180cb848"
import script from "./OrderLineComment.vue?vue&type=script&lang=js"
export * from "./OrderLineComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports